const constants = {
  JWT: "jwt",
};

export interface IToken {
  token: string;
  expires: string;
}

export interface IAsyncTokens {
  access: IToken;
  refresh: IToken;
}

export const getAsyncTokens = (): IAsyncTokens => {
  const tokens = localStorage.getItem(constants.JWT);
  if (tokens) {
    return JSON.parse(tokens);
  }
  return {
    access: {
      token: "",
      expires: "",
    },
    refresh: {
      token: "",
      expires: "",
    },
  };
};

export const setAsyncTokens = (tokens: IAsyncTokens): void => {
  localStorage.setItem(constants.JWT, JSON.stringify(tokens));
};

export const setAsyncClearAll = (): void => {
  localStorage.clear();
};
